// Tekster for pipeline pakke 2 (se pipelineViewMessages.ts). Egen fil så
// delene av pakken kan bygges hver for seg. Denne delen: tabellvisningen med
// massehandlinger, oppgavetype og mulighet i oppgaveskjemaet, og
// pipelinehandlingene i kommandopaletten.
export const norwegianPipelineTableMessages = {
  crm: {
    deals: {
      table: {
        name: "Navn",
        company: "Kunde",
        stage: "Stadium",
        one_time_value: "Engangsverdi",
        monthly_value: "Månedlig verdi",
        next_step: "Neste steg",
        owner: "Eier",
        expected_closing_date: "Forventet avslutning",
        days_in_stage: "Dager i stadiet",
        silent: "Stille",
        offer_valid_until: "Tilbud gyldig til",
        days: "%{smart_count} d",
        active_today: "Aktiv i dag",
        bulk: {
          owner: "Endre eier",
          owner_done: "Eier endret på %{smart_count} muligheter",
          move: "Flytt stadium",
          moved_done: "%{moved} av %{total} muligheter flyttet",
          none_open: "Ingen av de valgte mulighetene er åpne.",
          lost_title:
            "Merk %{smart_count} mulighet som tapt |||| Merk %{smart_count} muligheter som tapt",
          lost_description:
            "Tapsårsaken gjelder alle de valgte åpne mulighetene.",
          lost_done: "%{smart_count} muligheter merket som tapt",
        },
      },
    },
    tasks: {
      no_deal: "Ingen mulighet",
    },
    command: {
      view_table: "Vis som tabell",
      view_board: "Vis som tavle",
      deal_archived: "Arkivert",
      action: {
        show: "Vis",
      },
    },
  },
};

export const englishPipelineTableMessages = {
  crm: {
    deals: {
      table: {
        name: "Name",
        company: "Customer",
        stage: "Stage",
        one_time_value: "One-time value",
        monthly_value: "Monthly value",
        next_step: "Next step",
        owner: "Owner",
        expected_closing_date: "Expected close",
        days_in_stage: "Days in stage",
        silent: "Silent",
        offer_valid_until: "Offer valid until",
        days: "%{smart_count} d",
        active_today: "Active today",
        bulk: {
          owner: "Change owner",
          owner_done: "Owner changed on %{smart_count} opportunities",
          move: "Move stage",
          moved_done: "%{moved} of %{total} opportunities moved",
          none_open: "None of the selected opportunities are open.",
          lost_title:
            "Mark %{smart_count} opportunity as lost |||| Mark %{smart_count} opportunities as lost",
          lost_description:
            "The loss reason applies to all selected open opportunities.",
          lost_done: "%{smart_count} opportunities marked as lost",
        },
      },
    },
    tasks: {
      no_deal: "No opportunity",
    },
    command: {
      view_table: "Show as table",
      view_board: "Show as board",
      deal_archived: "Archived",
      action: {
        show: "Show",
      },
    },
  },
};
